import React from "react";
import { useNavigate } from "react-router-dom";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import "./auth.css";

/** Red inline alert used across the auth screens. */
export function AuthAlert({ children }) {
  return (
    <div className="auth-alert" role="alert">
      <ErrorOutlineIcon sx={{ fontSize: 18 }} />
      <span>{children}</span>
    </div>
  );
}

/**
 * Shared shell for sign in / register / forgot password (Sign In v2 design).
 * Left panel is intentionally static; client-specific artwork will go in
 * `.auth-side__slot`. The client header (logo + name) comes from the tenant
 * resolved by domain.
 */
export default function AuthLayout({ domainTenant, children }) {
  const navigate = useNavigate();
  const brandName = domainTenant?.name || "Training Center";
  const brandLogo = domainTenant?.logo || domainTenant?.icon || null;
  const year = new Date().getFullYear();

  const goBrowse = (e) => {
    e.preventDefault();
    navigate("/");
  };

  return (
    <div className="auth-root">
      <aside className="auth-side" aria-label="About the Training Center">
        <div>
          <b className="auth-side__wm">Responder Training Center</b>
          <small className="auth-side__by">by Atomic Solutions</small>
        </div>
        <div className="auth-side__slot">
          <div className="auth-side__eb">
            <i />
            Responder Training Center
          </div>
          <h2>
            Train, certify, and stay <em>current.</em>
          </h2>
          <p>One place for your courses, skill sign-offs, and certification records.</p>
        </div>
        <div className="auth-side__ft">© {year} Training Center</div>
      </aside>

      <div className="auth-mainc">
        <header className="auth-top">
          <div className="auth-top__brand">
            <span className="auth-logo">
              {brandLogo ? <img src={brandLogo} alt="" /> : brandName.charAt(0)}
            </span>
            <span>{brandName}</span>
          </div>
          <a className="auth-browse" href="/" onClick={goBrowse}>
            <SchoolOutlinedIcon sx={{ fontSize: 18 }} />
            Browse courses
          </a>
        </header>

        <main className="auth-main">
          <div className="auth-wrap">
            <div className="auth-client">
              <div className="auth-clogo">
                {brandLogo ? (
                  <img src={brandLogo} alt={`${brandName} logo`} />
                ) : (
                  brandName.charAt(0)
                )}
              </div>
              <div>
                <span className="auth-ceb">Training portal for</span>
                <b className="auth-cname">{brandName}</b>
              </div>
            </div>
            <div className="auth-card">{children}</div>
          </div>
        </main>
      </div>
    </div>
  );
}
